import { useEffect, useState, useRef } from "react";

import { ErrorBoundary } from "@sentry/react";
import { UncontrolledTooltip } from "reactstrap";
import { useTranslation } from "react-i18next";

const CustomTooltip = (props) => {

    const { target, content, className = "", trigger = "hover", placement = "top" } = props;
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const { t } = useTranslation();
    const tooltipRef = useRef(null);
    
    const [isTargetAvailable, setIsTargetAvailable] = useState(false);

    useEffect(() => {
        // Check if the target element is in the DOM
        const targetExists = document.getElementById(target);
        setIsTargetAvailable(!!targetExists);
    }, []);
    
    // Only implement useOutsideAlerter for click trigger
    useEffect(() => {
        if (trigger !== "click") return;

        function handleClickOutside (event) {
            const targetElement = document.getElementById(target);
            const isOutsideTooltip = tooltipRef.current && !tooltipRef.current.contains(event.target);
            const isOutsideTarget = targetElement && !targetElement.contains(event.target);

            if (isOutsideTooltip && isOutsideTarget) {
                setTooltipOpen(false);
            }
        }

        // Add event listener when tooltip is open
        if (tooltipOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        // Cleanup
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [tooltipOpen, trigger, target]);
    
    return (
        <ErrorBoundary
            onError={(error) => {
                let message = "";

                // Safely extract error message
                if (error instanceof Error) {
                    message = error.message;
                } else if (typeof error === "object" && error !== null && "message" in error) {
                    message = String((error).message);
                }

                // Ignore specific errors
                if (
                    message.includes("The target") ||
                message.includes("Failed to execute 'querySelectorAll'") ||
                message.includes("Invalid selector")
                ) {
                    return; // Silently ignore these errors
                }

                // Log other errors to Sentry
                console.error("Unhandled Error:", error);
            }}>
            {isTargetAvailable && (
                <div ref={tooltipRef}>
                    <UncontrolledTooltip
                        target={target}
                        placement={placement}
                        autohide={false}
                        isOpen={tooltipOpen}
                        trigger={trigger}
                        className={className}
                        toggle={() => setTooltipOpen(!tooltipOpen)}>
                        {typeof content === "string" ? t(content) : content}
                    </UncontrolledTooltip>
                </div>
            )}
        </ErrorBoundary>
    );

};

export default CustomTooltip;